module.exports = new __parcel__URL__("welcome-to-project-pages-dark.6a661445.png").toString();